import * as React from 'react';
import { Dispatch } from 'react-redux';

import { StoreState } from '../../../reducers';
import { sendRenameRequest, setIsRenaming, setRenameError } from '../../../containers/Editor/actions';
import { Wrapper, Input } from './styles';
import Utils from '../../../utils';

interface TitleProps {
	label: string;
	isError: boolean;
	dispatch: Dispatch<StoreState>;
}

const Title = ({ label, isError, dispatch }: TitleProps) => {
	const inputElement = React.useRef<HTMLInputElement>(null);
	const [value, setValue] = React.useState(label);

	const handleBlur = () => {
		if (!value) {
			return;
		}

		if (value !== label) {
			dispatch(sendRenameRequest(value));
		} else {
			dispatch(setIsRenaming(false));
		}
	};

	const handleSubmit = (e: React.FormEvent<HTMLFormElement>) => {
		e.preventDefault();
		inputElement.current!.blur();
	};

	React.useEffect(() => {
		setValue(label);
	}, [label]);

	React.useEffect(() => {
		if (isError) {
			dispatch(setRenameError(false));
		}
	}, [value]);

	return (
		<Wrapper>
			<form onSubmit={handleSubmit}>
				<Input
					type="text"
					ref={inputElement}
					value={value}
					isError={isError}
					onChange={e => setValue(e.target.value)}
					onFocus={() => dispatch(setIsRenaming(true))}
					onBlur={handleBlur}
					disabled={Utils.isEmbedMode()}
				/>
				<input
					type="submit"
					hidden={true}
				/>
			</form>
		</Wrapper>
	);
};

export default Title;



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Editor/Title/index.tsx